import { Interval } from 'date-fns'
import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Link, Typography } from '@mui/material'

import { MaskedTextGuard } from '../../../../../../components/MaskedTextGuard/MaskedTextGuard'
import { useDateTimeFormatter } from '../../../../../live-events/hooks/useDateTimeFormatter'

type LiveEventSubHeaderProps = {
  linkLabel?: string
  interval?: Interval
  date?: number | Date
  onLinkClick?: () => void
  children?: ReactNode
  showLimitedContent?: boolean
}

export const LiveEventSubHeader: FC<LiveEventSubHeaderProps> = ({ linkLabel, interval, date, onLinkClick, children, showLimitedContent }) => {
  const { t } = useTranslation()
  const dateFormatter = useDateTimeFormatter({ year: 'numeric', month: 'short', day: 'numeric', weekday: 'short' })
  const formattedDate = dateFormatter.format(date)
  const formattedInterval = t('common:interval_from_to', { from: dateFormatter.format(interval?.start), to: dateFormatter.format(interval?.end) })

  return (
    <Box className="LiveEventSubHeader">
      <Typography>
        <MaskedTextGuard reveal={!showLimitedContent} text={linkLabel} length={30}>
          {onLinkClick ? (
            <Link underline="none" onClick={onLinkClick} sx={{ fontSize: '17px', fontWeight: 'bold' }}>
              {linkLabel}
            </Link>
          ) : (
            linkLabel
          )}
        </MaskedTextGuard>
      </Typography>
      {children}
      {interval && (
        <Typography variant="body1">
          <MaskedTextGuard reveal={!showLimitedContent} text={formattedInterval} length={25} />
        </Typography>
      )}
      {date && (
        <Typography variant="body1">
          <MaskedTextGuard reveal={!showLimitedContent} text={formattedDate} length={20} />
        </Typography>
      )}
    </Box>
  )
}
